import { tv } from "@heroui/react";
import { Button } from "ds/ui";
import { FONT_SIZE_16 } from "ds_legacy/materials/typography";
import { useBackendNavbarErrors } from "dsl/atoms/Navbar/ErrorBanner/useBackendNavbarErrors";
import { CircleAlertIcon } from "lucide-react";

const errorBanner = tv({
  slots: {
    base: "bg-danger py-2 px-4 flex items-center text-body-md! text-white justify-between flex-col gap-4 desktop:flex-row",
    button: "self-end shrink-0 data-[focus-visible=true]:outline-white!",
    icon: "hidden desktop:flex shrink-0",
    message: "flex flex-row gap-4 flex-nowrap items-center w-full",
  },
});

export function ErrorBanner() {
  const errors = useBackendNavbarErrors();

  const classes = errorBanner();

  return errors.map((error, index) => (
    <div key={index} className={classes.base()}>
      <div className={classes.message()}>
        <CircleAlertIcon
          aria-hidden="true"
          className={classes.icon()}
          size={FONT_SIZE_16}
        />
        <p>{error.message}</p>
      </div>
      {error.button && (
        <>
          <Button
            className={classes.button()}
            color="white"
            id={error.button.id}
            size="sm"
            title={error.button.title}
            variant="light"
            onPress={() => {
              error.button?.onClick();
            }}
          >
            {error.button.title}
          </Button>
        </>
      )}
    </div>
  ));
}
